/* eslint-disable no-undef */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-filename-extension */
import { AutoCompleteSearchInput, NoDataCard } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { getEmoji } from '@nile/mangifera/src/Pebbles/Views';
import { SVGIcon } from '@superops/super-icons';
import {
  Button,
  ButtonGroup,
  Checkbox,
  DisplayText,
  Heading,
  ResourceItem,
  Sheet,
  TextStyle
} from '@superops/ui-design-system';
import { clone, isEmpty } from 'lodash';
import React, {
  createContext,
  DispatchWithoutAction,
  PropsWithChildren,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useState
} from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { ReactSortable } from 'react-sortablejs';
import styled from 'styled-components';

const ManageViewContainer = styled.div`
  position: fixed;
  width: calc(100% - 20px);
  bottom: 0;
  height: 38px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-top: 1px solid #dfdfdf;
  background: #f7f7fc;

  span {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
`;

const EmojiWrapper = styled.span`
  width: 20px;
  margin-right: 5px;
`;

const SelectionWrapper = styled.div`
  padding: 12px;
  overflow: ${(props) => (props.dynamicHeight ? 'hidden' : 'auto')};

  .text-with-no-checkbox {
    color: rgba(0, 0, 0, 0.8) !important
    font-weight: 500;
    font-size: 14px;
  }
  .Search-Input {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .Polaris-Choice {
    display: inline-flex;
    justify-content: flex-start;
    /* padding: 0.4rem 0; */
    cursor: pointer;
    height: 24px;
    align-items: center;
  }
`;

const SortItem = styled.div`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  cursor: pointer;
  border-radius: 4px;
  .Polaris-Choice__Control {
    margin-right: 23px !important;
  }
  .Polaris-Choice__Label {
    font-weight: 500 !important;
  }
`;

interface IManageLeftPaneContext {
  isSheetVisible: boolean;
  toggleSheet: React.DispatchWithoutAction;
}

type SectionListArrayType = {
  list: any[];
  heading: React.ReactNode;
  isChecked: boolean;
  order: number;
  section: string;
};

type SectionListType = Record<string, SectionListArrayType>;

export interface ManageSheetProps {
  className?: string;
  dynamicHeight?: boolean;
  meta: {
    heading: React.ReactNode;
  };
  noSearchBar?: boolean;
  data: Record<string, Omit<SectionListArrayType, 'heading'>>;
  renderListItem?: (
    item: any,
    render: {
      dragHandle: ReactNode;
      checkbox: (label?: ReactNode) => ReactNode;
    },
    props: {
      isDisabled: boolean;
    }
  ) => ReactNode;
  onSave: (
    data: Array<SectionListArrayType>,
    toggleSheet: DispatchWithoutAction
  ) => void;
  onSaveLoading: boolean;
}

interface ManageLeftNavPaneComposition {
  OpenSheetButton?: React.FC<{}>;
  Sheet?: React.FC<ManageSheetProps>;
}
export const ManageLeftPaneContext = createContext(null);

type ManageLeftPaneProps = React.FC<{}>;

export const ManageLeftPane: ManageLeftPaneProps &
  ManageLeftNavPaneComposition = function ManageLeftPane({
  children
}: PropsWithChildren<{}>) {
  const [isSheetVisible, toggleSheet] = useReducer((active) => !active, false);
  return (
    <ManageLeftPaneContext.Provider value={{ isSheetVisible, toggleSheet }}>
      {children}
    </ManageLeftPaneContext.Provider>
  );
};

ManageLeftPane.OpenSheetButton = function ManageLeftPaneOpenSheetButton() {
  const { toggleSheet } = useContext(ManageLeftPaneContext);

  return (
    <ManageViewContainer onClick={toggleSheet}>
      <SVGIcon name="Adjuster" />
      <span className="ml-10">
        <FormattedMessage id="leftPane.manageView" />
      </span>
    </ManageViewContainer>
  );
};

ManageLeftPane.Sheet = function ManageLeftPaneSheet({
  className,
  dynamicHeight,
  meta,
  noSearchBar,
  data,
  renderListItem,
  onSave,
  onSaveLoading
}: ManageSheetProps) {
  const { isSheetVisible, toggleSheet } = useContext(ManageLeftPaneContext);
  const [filterExpression, setFilterExpression] = useState('');

  const { id: paramId } = useParams();

  // const [sectionListData, setSectionListData] = useReducer(
  //   (state: SectionListType, newState: Partial<SectionListType>) => ({
  //     ...state,
  //     ...newState
  //   }),
  //   data
  // );

  const [sectionDragList, setSectionDragList] = useState(() => {
    return Object.entries(data).reduce((acc, [key, value], index) => {
      acc[value.order ?? index] = {
        ...value,
        section: key
      };

      return acc;
    }, []);
  });

  useEffect(() => {
    setSectionDragList(
      Object.entries(data).reduce((acc, [key, value], index) => {
        acc[value.order ?? index] = {
          ...value,
          section: key
        };

        return acc;
      }, [])
    );
  }, [data, isSheetVisible]);

  const filterSearch = useCallback((value) => {
    setFilterExpression(value.toLowerCase());
    // Reset the parent checkbox state after cledaring search query
    // if (!value) {
    //   const clonedsectionListData = clone(sectionListData);
    //   Object.keys(clonedsectionListData).forEach((sectionHeader) => {
    //     const isAllChecked = clonedsectionListData[sectionHeader].list.every(
    //       (item) => item.isChecked
    //     );
    //     clonedsectionListData[sectionHeader].isChecked = isAllChecked;
    //   });
    //   setSectionListData(clonedsectionListData);
    // }
  }, []);

  function handleSave() {
    onSave(sectionDragList, toggleSheet);
  }

  // const filteredData = useMemo(() => {
  //   if (!filterExpression) return {};
  //   const filter = (arr) =>
  //     arr.filter((item) =>
  //       item.name.toLowerCase().includes(filterExpression.toLowerCase())
  //     );

  //   const temp: SectionListType = {};
  //   Object.entries(sectionListData).forEach(([key, { list, ...rest }]) => {
  //     const result = filter(list);
  //     if (result.length) {
  //       temp[key] = {
  //         ...rest,
  //         list: filter(list)
  //       };
  //     }
  //   });
  //   return temp;
  // }, [filterExpression, sectionListData]);

  const filteredDragListArr = useMemo(() => {
    if (!filterExpression) return sectionDragList;
    const filter = (arr) =>
      arr.filter((item) =>
        item.name.toLowerCase().includes(filterExpression.toLowerCase())
      );

    const temp: SectionListType[] = [];
    sectionDragList.forEach(({ list, ...rest }) => {
      const result = filter(list);
      if (result.length) {
        temp.push({
          ...rest,
          list: filter(list)
        });
      }
    });
    return temp;
  }, [sectionDragList, filterExpression]);

  const renderDragHandle = filterExpression ? null : (
    <span className="dragHandle mr8 cursor-move" style={{ opacity: '0.5' }}>
      <SVGIcon name="Reorder" />
    </span>
  );

  const renderSectionHeaderDragHandle = filterExpression ? null : (
    <span
      className="headerDragHandle mr8 cursor-move"
      style={{ opacity: '0.5' }}
    >
      <SVGIcon name="Reorder" />
    </span>
  );

  function updateCheckedSectionData(
    isChecked: boolean,
    id: string,
    sectionHeaderKey: string
  ) {
    // const clonedSectionData = clone(sectionListData);
    // if (filterExpression) {
    //   const { list } = filteredData[sectionHeaderKey];
    //   const { id } = list[index];
    //   const newList = clonedSectionData[sectionHeaderKey].list.map((item) => {
    //     if (item.id === id) {
    //       // eslint-disable-next-line no-param-reassign
    //       item.isChecked = isChecked;
    //     }
    //     return item;
    //   });

    //   clonedSectionData[sectionHeaderKey].list = newList;
    //   return setSectionListData(clonedSectionData);
    // }
    // const { list } = clonedSectionData[sectionHeaderKey];
    // list[index].isChecked = isChecked;
    // const isAllSiblingsChecked = list.every((item) => item.isChecked);
    // clonedSectionData[sectionHeaderKey].isChecked = isAllSiblingsChecked;
    // return setSectionListData(clonedSectionData);

    setSectionDragList(
      sectionDragList.map((item) => {
        if (item.section === sectionHeaderKey) {
          return {
            ...item,
            list: item.list.map((listItem) => {
              if (listItem.id === id) {
                return {
                  ...listItem,
                  isChecked
                };
              }

              return listItem;
            })
          };
        }

        return item;
      })
    );
  }

  const renderCheckbox = (
    item: any,
    label: ReactNode,
    sectionHeaderKey: string
  ) => (
    <Checkbox
      id={`manage-view-${item.id}`}
      label={label ?? item.name}
      checked={item.isChecked}
      disabled={item.id === paramId}
      onChange={(checked) => {
        updateCheckedSectionData(checked, item.id, sectionHeaderKey);
      }}
    />
  );

  // function updateHeaderChecked(isChecked: boolean, sectionHeaderKey: string) {
  //   const clonedSectionData = clone(sectionListData);

  //   clonedSectionData[sectionHeaderKey].isChecked = isChecked;
  //   if (filterExpression) {
  //     const childrenIds = filteredData[sectionHeaderKey].list.map(
  //       (item) => item.id
  //     );

  //     clonedSectionData[sectionHeaderKey].list.map((item) => {
  //       if (childrenIds.includes(item.id)) {
  //         // eslint-disable-next-line no-param-reassign
  //         item.isChecked = isChecked;
  //       }
  //       return item;
  //     });
  //     return setSectionListData(clonedSectionData);
  //   }
  //   clonedSectionData[sectionHeaderKey].list = clonedSectionData[
  //     sectionHeaderKey
  //   ].list.map((item) => {
  //     // eslint-disable-next-line no-param-reassign
  //     item.isChecked = isChecked;
  //     return item;
  //   });
  //   return setSectionListData(clonedSectionData);
  // }

  return (
    <Sheet
      open={isSheetVisible}
      onClose={toggleSheet}
      onExit={() => {
        setFilterExpression('');
      }}
      accessibilityLabel="Manage Views"
    >
      <SelectionWrapper
        className={`vw30 vh100 selection-sheet ${className || ''}`}
        dynamicHeight={dynamicHeight}
      >
        <div className="flex fcol">
          <div className="flex" data-qa="selectinSheetDoneBtn">
            <Heading element="h1">{meta?.heading}</Heading>
            <div className="fx mlauto">
              <ButtonGroup>
                <Button onClick={toggleSheet}>
                  {/* @ts-expect-error */}
                  <FormattedMessage id="common.cancel" />
                </Button>
                <Button primary onClick={handleSave} loading={onSaveLoading}>
                  {/* @ts-expect-error */}
                  <FormattedMessage id="common.save" />
                </Button>
              </ButtonGroup>
            </div>
          </div>

          {!noSearchBar && (
            <AutoCompleteSearchInput debouncedFilter={filterSearch} />
          )}

          <div
            className={`${dynamicHeight ? '' : 'scroll-in '} ${noSearchBar &&
              'mt-20'}`}
          >
            {filterExpression && isEmpty(filteredDragListArr) ? (
              <div className="full-width flex center jcenter mt-30">
                <NoDataCard
                  imageURL={`url(${envConfig.imageRoot}svg/documents-empty-state.svg)`}
                  text={<FormattedMessage id="common.noData" />}
                  type="secondary"
                />
              </div>
            ) : (
              <ReactSortable
                className="sort-wrapper"
                list={sectionDragList}
                handle=".headerDragHandle"
                setList={(sectionList) => {
                  if (filterExpression) return;
                  setSectionDragList(
                    sectionList.map((item, index) => {
                      return {
                        ...item,
                        order: index
                      };
                    })
                  );
                }}
                animation={200}
              >
                {filteredDragListArr.map(
                  ({ list, heading, section: sectionKey }) => {
                    return (
                      <div
                        className="mb10 gen"
                        key={sectionKey}
                        style={{ display: list.length ? 'block' : 'none' }}
                      >
                        {/* <Checkbox
                      label={
                        <Heading element="h3" weight="Bold">
                          <div className="uppercase">{heading}</div>
                        </Heading>
                      }
                      checked={isChecked}
                      onChange={(check) => {
                        updateHeaderChecked(check, sectionKey);
                      }}
                    /> */}
                        <div className="fx">
                          {renderSectionHeaderDragHandle}
                          <Heading element="h3" weight="Bold">
                            <div className="uppercase f-12">{heading}</div>
                          </Heading>
                        </div>
                        {/* @ts-expect-error */}
                        <ReactSortable
                          className="sort-wrapper"
                          list={list}
                          handle=".dragHandle"
                          setList={(l) => {
                            if (filterExpression) return;
                            setSectionDragList((currList) => {
                              return currList.map((item) => {
                                if (item.section === sectionKey) {
                                  return {
                                    ...item,
                                    list: l
                                  };
                                }
                                return item;
                              });
                            });
                          }}
                          animation={200}
                        >
                          {list.map((item) => {
                            if (renderListItem) {
                              return renderListItem(
                                item,
                                {
                                  dragHandle: renderDragHandle,
                                  checkbox: (label) =>
                                    renderCheckbox(item, label, sectionKey)
                                },
                                { isDisabled: paramId === item.id }
                              );
                            }
                            return (
                              <ListItem
                                key={item.id}
                                item={item}
                                renderCheckbox={renderCheckbox(
                                  item,
                                  <div className="fx">
                                    <EmojiWrapper>
                                      {getEmoji({
                                        ...item,
                                        section: sectionKey
                                      })}
                                    </EmojiWrapper>
                                    {item.name}
                                  </div>,
                                  sectionKey
                                )}
                                renderDragHandle={renderDragHandle}
                              />
                            );
                          })}
                        </ReactSortable>
                      </div>
                    );
                  }
                )}
              </ReactSortable>
            )}
          </div>
        </div>
      </SelectionWrapper>
    </Sheet>
  );
};

function ListItem({ renderDragHandle, renderCheckbox, item }) {
  return (
    <SortItem key={item.id}>
      <ResourceItem
        id={item.id}
        accessibilityLabel="view-item"
        onClick={() => {}}
      >
        <DisplayText element="h3">
          <TextStyle>
            <div className="flex center">
              {renderDragHandle}
              {renderCheckbox}
            </div>
          </TextStyle>
        </DisplayText>
      </ResourceItem>
    </SortItem>
  );
}
